import React from 'react';

import { BaseModal } from '../../../../../../components/BaseModal';

interface RemoveSupplierMemberModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  memberName: string;
  isRemoving: boolean;
}

export const RemoveSupplierMemberModal: React.FC<
  RemoveSupplierMemberModalProps
> = ({ isOpen, onClose, onConfirm, memberName, isRemoving }) => {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      title="Are you sure you want to remove this team member from the distributor?"
      isDismissable={!isRemoving}
      hideCloseButton
      footerContent={{
        onCancel: onClose,
        onConfirm,
        isLoading: isRemoving,
        isDisabled: isRemoving,
        isDestructive: true,
        confirmText: isRemoving ? 'REMOVING...' : 'REMOVE',
        cancelText: 'CANCEL',
      }}
    >
      <p className="text-default-500 text-sm">
        <span className="font-medium text-foreground">{memberName}</span> will
        be unlinked from this distributor.
      </p>
    </BaseModal>
  );
};
